export default __webpack_public_path__ + "static/media/back-btn.5dd1e3f9.svg";